export const malgorzataStarczewska = {
    'mydrId': 'małgorzatastarczewska',
    'firstName': 'Małgorzata',
    'lastName': 'Starczewska',
    'profession': 'Lekarz rezydent psychiatrii',
    'avatar': 'malgorzata-starczewska.webp',
    'slug': 'psychiatra-malgorzata-starczewska',
    'locations': ['torun'],
    'services': [
        ['psychiatry', 'adult']
    ]
}